export default __webpack_public_path__ + "static/media/galerie8.f8fb5d89.jpg";